import Cookies from 'js-cookie';
import { v4 as uuid } from 'uuid';

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    /**
     * Cohesion pageType for the current page. Set this to have the webContext
     * autofilled by tagular along with the page type.
     */
    chsn_pageType?: string;
  }
}

/**
 * Fill the Window page tracking variables to permit Tagular/Cohesion to full in
 * the webContext automatically.
 * @param pageType The page type to be submitted along with the event.
 * @param override Should force the change
 */
export function pageTrackingObjectUpdate(pageType: string | undefined, override: boolean = false): void {
  if (!override && window.chsn_pageType !== undefined && window.chsn_pageType !== pageType) {
    throw new Error('You are not permitted to override the page type.');
  }
  window.chsn_pageType = pageType;
}

/**
 * Make Near Slugs from Plain Strings for ease of eventing.
 *
 * @example
 *   "Computer Science" => "computer-science"
 *   "Humanities & Arts" => "humanities-&-arts"
 *   "Someone added a space " => "someone-added-a-space"
 *
 * @param x Input String
 */
export function hyphenateForTagular(x: string): string {
  return x
    .trim()
    .toLowerCase()
    .replace(/[^\w&]/g, '-');
}

/**
 * Issues a new Correlation ID
 */
export function issueCorrelationID() {
  return uuid();
}

/**
 * Gets the base domain of the site, this is the last 2 sections, the domain and TLD.
 *
 * This will not work on sites with 2 level TLDs like `example.co.uk`.
 */
function getBaseDomain() {
  const { hostname } = window.location;
  const parts = hostname.split('.');
  return parts.length > 2 ? parts.slice(-2).join('.') : hostname;
}

/**
 * Fetch a single query parameter
 * @param name Name of the parameter
 */
function getQueryParameter(name: string): string | null {
  const params = new URLSearchParams(window.location.search);

  return params.get(name);
}

/**
 * Fetch or Create a Tagular CorrelationID. This also refreshes the cookie's expiry.
 *
 * @param reset Reset the cookie id if its present
 */
export function getCorrelationID(reset = false): string {
  const COOKIE_NAME = 'tglr_correlation_id';
  const PARAM_NAME = 'correlationId';

  let paramId = getQueryParameter(PARAM_NAME) || (reset ? null : Cookies.get(COOKIE_NAME));

  if (!paramId) {
    paramId = issueCorrelationID();
  }

  Cookies.set(COOKIE_NAME, paramId, {
    expires: 1 / 48 /* 30 mins */,
    domain: `.${getBaseDomain()}`,
  });

  return paramId;
}
